module.exports = __webpack_public_path__ + "static/media/f8.dae3cb71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/f8.jpg
// module id = 401
// module chunks = 0